var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgPokerRng = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9372_70123)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.0152 7.71459L10.6452 7.34603L8.82878 5.53511C8.64665 5.35312 8.35151 5.35312 8.16938 5.53511L6.35742 7.34152L5.98538 7.71253C5.39538 8.30546 5.39776 9.2644 5.9907 9.8544C6.49133 10.3525 7.26978 10.4386 7.86708 10.0617L7.66127 11.1723C7.62466 11.3688 7.75432 11.5578 7.95084 11.5944C7.97277 11.5985 7.99504 11.6005 8.01734 11.6005H8.98283C9.18274 11.6007 9.3449 11.4387 9.34501 11.2388C9.34501 11.2165 9.34297 11.1942 9.33889 11.1723L9.13067 10.0555C9.72967 10.435 10.5116 10.3493 11.0141 9.84899C11.6038 9.26224 11.6062 8.30859 11.0194 7.71891C11.0181 7.71747 11.0166 7.71603 11.0152 7.71459Z",
    fill: "#CCD6F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.43041 8.29179C2.47975 6.82561 3.06003 5.42724 4.06328 4.35692L4.06015 4.35414L2.34225 2.63623C0.883938 4.16362 0.0486208 6.18058 0 8.29179H2.42937H2.43041Z",
    fill: "#CCD6F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.35707 4.06328C5.42733 3.06012 6.82552 2.47983 8.29158 2.43041C8.29138 2.42914 8.29138 2.42785 8.29158 2.42658V0C6.18063 0.0486208 4.16396 0.883823 2.63672 2.3419L4.35428 4.06015L4.35707 4.06328Z",
    fill: "#CCD6F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6429 12.9364C11.5726 13.9398 10.1742 14.5202 8.70801 14.5696C8.70821 14.5709 8.70821 14.5722 8.70801 14.5734V17C10.8197 16.9519 12.8373 16.1166 14.3649 14.6578L12.647 12.9395L12.6429 12.9364Z",
    fill: "#CCD6F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.29179 14.5696C6.82543 14.5203 5.42692 13.9399 4.35655 12.9364L4.35411 12.9395L2.63623 14.6578C4.16388 16.1166 6.18144 16.9519 8.29319 17V14.5734C8.2925 14.5722 8.29205 14.571 8.29179 14.5696Z",
    fill: "#CCD6F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.06322 12.6428C3.06006 11.5725 2.47977 10.1743 2.43035 8.70825H0.000976562C0.0488215 10.8198 0.883794 12.8374 2.34219 14.3652L4.06009 12.6469C4.06078 12.6453 4.06187 12.6439 4.06322 12.6428Z",
    fill: "#CCD6F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5694 8.70825C14.5201 10.1744 13.9398 11.5728 12.9365 12.6431C12.9377 12.6437 12.9388 12.6446 12.9397 12.6456L14.6576 14.3652C16.1163 12.8375 16.9517 10.82 16.9998 8.70825H14.5704H14.5694Z",
    fill: "#CCD6F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9365 4.35723C13.9397 5.42749 14.52 6.82568 14.5694 8.29175H16.9988C16.9504 6.1808 16.1154 4.16398 14.6576 2.63654L12.9397 4.35444L12.9365 4.35723Z",
    fill: "#CCD6F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.70801 2.43041C10.1742 2.47975 11.5726 3.06003 12.6429 4.06328L12.6457 4.06015L14.3632 2.3419C12.8359 0.883737 10.8191 0.0485346 8.70801 0V2.42658C8.70821 2.42785 8.70821 2.42914 8.70801 2.43041Z",
    fill: "#CCD6F4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9372_70123"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPokerRng);
export default ForwardRef;